import React, { useState, useRef } from "react";
import {
    Box,
    TextField,
    Button,
    IconButton,
    Stack,
    Typography,
    Paper,
    Menu,
    MenuItem,
    ListItemIcon,
    ListItemText
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloseIcon from "@mui/icons-material/Close";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { useAddChangeTrackerCommentMutation } from "store/slices/apis/changeTrackerComment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";

const AddCommentChange = (props) => {
    const { data } = props

    const [comment, setComment] = useState("");
    const [attachments, setAttachments] = useState([]);
    const [anchorEl, setAnchorEl] = useState(null);
    const fileInputRef = useRef(null);

    const dispatch = useDispatch();
    const [addClaimComment] = useAddChangeTrackerCommentMutation();

    // const handleFileChange = (e) => {
    //     const files = Array.from(e.target.files);
    //     if (files.length > 0) {
    //         setAttachments(prevAttachments => [...prevAttachments, ...files]);
    //     }
    //     // Reset input
    //     if (fileInputRef.current) {
    //         fileInputRef.current.value = null;
    //     }
    // };

    // const handleRemoveFile = (index) => {
    //     setAttachments(prev => prev.filter((_, i) => i !== index));
    // };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type },
                close: false,
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleSubmit = async () => {
        // console.log("comment data", attachments, comment);
        if (!comment.trim()) {
            openNotification("Please fill comment", "error");
            return;
        }

        // const formData = new FormData();
        // formData.append("Comment", comment);
        // formData.append("ProjectRiskId", data?.projectRiskId);

        // attachments.forEach((file) => {
        //     formData.append("Attachments", file);
        // });
        const reqBody = {
            comment: comment,
            changeId: data?.changeId,
            commentType: 'ChangeComment',
            // parentCommentId:"",
            IsInternal: true
        }

        try {
            const response = await addClaimComment(reqBody).unwrap();
            openNotification("Comment added successfully", "success");
            setComment("");
            setAttachments([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;
            }
            if (props.onCommentAdded) {
                props.onCommentAdded();
            }
        } catch (error) {
            openNotification(error?.error ?? "Something is wrong", "error");
        }
    };

    return (
        <Paper sx={{ borderRadius: 2, boxShadow: 'none', p: 2 }}>
            <Stack spacing={1}>
                <TextField
                    fullWidth
                    name="comment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    multiline
                    rows={3}
                    placeholder="Write a comment..."
                    InputProps={{
                        sx: {
                            backgroundColor: "#fff",
                            "& textarea::placeholder": {
                                fontWeight: 400,
                                fontSize: "16px",
                                color: "#0A0A0C",
                            },
                            "& textarea": {
                                fontWeight: 400,
                                fontSize: "16px",
                                color: "#0A0A0C",
                            },
                        },
                    }}
                />

                <Stack direction="row" spacing={1} alignItems="center">
                    {/* <IconButton component="label">
                        <AttachFileIcon />
                        <input
                            hidden
                            type="file"
                            multiple
                            onChange={handleFileChange}
                            ref={fileInputRef}
                        />
                    </IconButton> */}


                    {/* {attachments.length > 0 && (
                        <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>

                            {attachments.slice(0, 2).map((file, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        backgroundColor: '#f5f5f5',
                                        borderRadius: '4px',
                                        padding: '4px 8px',
                                        gap: 1
                                    }}
                                >
                                    <InsertDriveFileIcon fontSize="small" color="action" />
                                    <Typography variant="body2" sx={{ maxWidth: '150px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {file.name}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() => handleRemoveFile(index)}
                                        sx={{ padding: '2px' }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                            ))}


                            {attachments.length > 2 && (
                                <>
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            backgroundColor: '#f5f5f5',
                                            borderRadius: '4px',
                                            padding: '4px 8px',
                                            gap: 1,
                                            cursor: 'pointer'
                                        }}
                                        onClick={handleMenuOpen}
                                    >
                                        <Typography variant="body2">
                                            +{attachments.length - 2} more
                                        </Typography>
                                        <MoreVertIcon fontSize="small" />
                                    </Box>

                                    <Menu
                                        anchorEl={anchorEl}
                                        open={Boolean(anchorEl)}
                                        onClose={handleMenuClose}
                                        PaperProps={{
                                            sx: {
                                                maxHeight: 200,
                                                width: '250px'
                                            }
                                        }}
                                    >
                                        {attachments.slice(2).map((file, index) => (
                                            <MenuItem
                                                key={index + 2}
                                                sx={{
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}
                                            >
                                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
                                                    <ListItemIcon>
                                                        <InsertDriveFileIcon fontSize="small" />
                                                    </ListItemIcon>
                                                    <ListItemText
                                                        primary={file.name}
                                                        primaryTypographyProps={{
                                                            sx: {
                                                                overflow: 'hidden',
                                                                textOverflow: 'ellipsis',
                                                                whiteSpace: 'nowrap'
                                                            }
                                                        }}
                                                    />
                                                </Box>
                                                <IconButton
                                                    size="small"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleRemoveFile(index + 2);
                                                    }}
                                                >
                                                    <CloseIcon fontSize="small" />
                                                </IconButton>
                                            </MenuItem>
                                        ))}
                                    </Menu>
                                </>
                            )}
                        </Box>
                    )} */}

                    <Box flexGrow={1} />

                    <Button
                        onClick={handleSubmit}
                        variant="contained"
                        sx={{
                            backgroundColor: "#00344C",
                            borderRadius: "25px",
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "14px",
                            color: "#FFFFFF",
                            px: "20px",
                            py: "15px",
                        }}
                    >
                        Comment
                    </Button>
                </Stack>
            </Stack>
        </Paper>
    );
};

export default AddCommentChange;